/* Chula — search panel
 * asset rev 2026-09-29b — bumped to mint a fresh CDN content hash after the
 * previous push's versioned URL served the PREVIOUS build's minified bytes.
 *
 * Extracted from snippets/chula-search-panel.liquid on 2026-09-20.
 *
 * It was an inline <script> in the page body, which meant this file's bytes
 * were re-sent and re-parsed on EVERY page of the site and could never be
 * cached. As a theme asset it is fetched once, cached for the session, and
 * `defer` keeps it off the parser's critical path. Nothing else changed —
 * the code below is the inline block verbatim, with its Liquid comments
 * turned into JavaScript ones.
 */

(function () {
    var root = document.getElementById('chula-search-panel');
    if (!root) return;

    /* The panel MUST hang off <body>. It is rendered inside the header
       section, and header.shopify-section carries transform:
       matrix(1,0,0,1,0,0) — an identity transform, but any transform other
       than `none` makes an element the containing block for its
       position:fixed descendants. Left in place, `.chsr { inset: 0 }`
       resolved against the header instead of the viewport and the panel sat
       16px off the right edge of the screen. Exactly the same trap as the
       newsletter popup's scrim, arriving from the opposite direction: there
       the transform was on the element itself, here it is on an ancestor.
       Prestige's own dialogs solve this with shouldAppendToBody; this is
       that, done by hand. */
    if (root.parentElement !== document.body) document.body.appendChild(root);

    /* Belt and braces for a stale edge-cached PAGE. The snippet no longer
       renders <predictive-search>, but this panel's markup is inline in the
       page HTML, and Shopify edge-caches that — so for a short window after a
       push a visitor can be served OLD markup (carrying the element and the
       form's aria-owns hook) alongside THIS build of the script. Left alone,
       that element binds via aria-owns and fetches /search/suggest on every
       keystroke, rendering a second, unscoped set of products over the ones
       this file fetches.

       Order matters — drop aria-owns BEFORE removing the element, so the custom
       element cannot bind during the same tick. Both lines are no-ops against
       current markup and cost one querySelector each. */
    var legacyForm = root.querySelector('form[aria-owns="chula-predictive-search"]');
    if (legacyForm) legacyForm.removeAttribute('aria-owns');
    var legacyEl = root.querySelector('[data-chsr-legacy]');
    if (legacyEl) legacyEl.remove();

    var panel = root.querySelector('.chsr__panel');
    var input = root.querySelector('[data-chsr-input]');
    var opener = null;
    var scrollY = 0;

    function lock() {
      /* Scroll mechanics delegated to the shared refcounted lock. A private
         copy here was measured losing the visitor's place: scrolled to 700, open
         search, hand off to the wishlist, close — back at 0, because this lock had
         already fixed the body when chulaPageLock read window.scrollY. The class
         stays; it does more than lock, including hiding the header counts. */
      if (window.chulaPageLock) window.chulaPageLock.lock();
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('chula-search-open');
      /* overflow:hidden alone does not hold on iOS — the body has to leave
         flow with a negative top. */
      if (!window.chulaPageLock) {
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.width = '100%';
      }
    }

    function unlock() {
      document.body.classList.remove('chula-search-open');
      if (window.chulaPageLock) { window.chulaPageLock.unlock(); return; }
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function open(trigger) {
      if (root.classList.contains('is-open')) return;
      opener = trigger || null;
      root.hidden = false;
      lock();
      /* Never gate this on requestAnimationFrame — rAF does not fire in a
         hidden or throttled tab, which leaves the page locked behind a
         fully transparent overlay. A forced reflow is synchronous and the
         transition still runs. */
      void panel.offsetHeight;
      root.classList.add('is-open');
      /* Opener deliberately null: this panel already returns focus itself in
         close(), and has a keepFocus handoff case the trap does not know
         about. The trap is used here only to contain Tab inside the panel. */
      if (window.chulaFocusTrap) window.chulaFocusTrap.activate(root, null);
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    }

    function close(keepFocus) {
      if (!root.classList.contains('is-open')) return;
      if (window.chulaFocusTrap) window.chulaFocusTrap.release(root);
      /* Drop any request still in flight. Without this a debounced fetch
         fired on the last keystroke lands after the panel has closed, writes
         results into a hidden column and leaves `is-loading` set — which then
         shows on the NEXT open. */
      abortPending();
      root.classList.remove('is-open');
      unlock();
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 700);
      /* Return focus to the opener, not to a stashed activeElement — a click
         does not focus a button on macOS Safari. preventScroll so the focus
         does not undo the scroll position the unlock just restored.

         keepFocus is passed when this close is a handoff to another panel in
         the shared icon row: throwing focus back to the header's search link
         there would drop a keyboard user behind the panel that is opening. */
      if (opener && !keepFocus) {
        try { opener.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    /* Intercept the header's search link. If this script never runs the
       link still navigates to /search, which is the correct fallback. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.header__search-link a, [data-chsr-open]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
        return;
      }
      if (e.target.closest('[data-chsr-close]')) {
        e.preventDefault();
        close();
        return;
      }

      /* Another surface in the shared icon row. Close this panel and leave
         the rest alone: the item's own opener attribute is handled by that
         panel's listener (or, for cart, by Prestige's aria-controls
         delegation), and every one of those runs after this file's. No
         preventDefault — the handler that opens the target owns that.

         unlock() above is synchronous and restores the scroll position
         before any of them read window.scrollY, which is what keeps the two
         styles of page lock in this theme from fighting. */
      if (root.classList.contains('is-open') && e.target.closest('[data-chula-panel-nav]')) {
        close(true);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    var submit = root.querySelector('[data-chsr-submit]');

    function syncQuery() {
      var has = input.value.trim().length > 0;
      root.classList.toggle('has-query', has);
      if (submit) submit.disabled = !has;
    }

    var col = root.querySelector('[data-chsr-col-results]');
    var scroller = root.querySelector('[data-chsr-scroll]');
    var countEl = root.querySelector('[data-chsr-count]');
    var seeall = root.querySelector('[data-chsr-seeall]');
    var seeallLink = root.querySelector('[data-chsr-seeall-link]');
    var queriesSlot = root.querySelector('[data-chsr-queries-slot]');
    var slot = root.querySelector('[data-chsr-results]');
    var countAbort = null;
    var countTimer = null;

    /* Cancel both halves of a pending search: the debounce that has not fired
       yet AND the request that already has. Called from close() — a function
       declaration, so it is hoisted and safe to reference from code defined
       above this line. */
    function abortPending() {
      if (countTimer) { clearTimeout(countTimer); countTimer = null; }
      if (countAbort) { countAbort.abort(); countAbort = null; }
      root.classList.remove('is-loading');
      if (slot) slot.setAttribute('aria-busy', 'false');
    }

    /* ──────────────────────────────────────────────────────────────────────
       INTENT RESOLVER

       Why this exists, measured on the live store 2026-09-29:
         q=dress -> 38 results, 27 of them dresses.
         precision 27/38 (71%)   recall 27/27 (100%)
       The 11 false positives were 7 Shirts & Tops, The Film Áo Dài, Tokyo
       Imperial Bolero, New York Iron Pants and Anaglyph Coat.

       Nothing was MISSING. Shopify's relevance already finds every dress; it
       just also returns about a third too much. So this resolver's job is to
       EXCLUDE, not to broaden — it turns words the catalogue actually knows
       into Search & Discovery facets and leaves everything else alone.

       Facets verified present on the live search page:
         filter.p.product_type             the 6 exact strings below
         filter.v.t.shopify.color-pattern  14 standard taxonomy buckets
         filter.v.t.shopify.fabric         Bamboo/Cotton/Linen/Silk/Digital
         filter.v.option.size              XS S M L XL One size

       The colour facet reads the PRODUCT-level shopify.color-pattern
       metafield, not just the 12 products with a Colour variant option:
       q=dress + Black returned 19 of 38, and the taxonomy already folds the
       store's own names (noir, obsidian, coal) into Black. That is why a
       shopper can type "black" even though no product is called black and
       only 12 carry a Colour variant.

       A word this map does not know falls straight through to free text, so
       an unrecognised query behaves exactly as it does today. ────────────── */

    /* Product types, EXACTLY as filter.p.product_type expects them — these
       strings came off the live facet, including the inconsistent casing of
       'Long dress' vs 'Short Dress'. Do not "tidy" them. */
    var T_LONG = 'Long dress', T_SHORT = 'Short Dress', T_BOLERO = 'Bolero',
        T_COAT = 'Coats & Capes', T_TOP = 'Shirts & Tops', T_PANTS = 'Pants';

    var TYPE_WORDS = {
      bolero: [T_BOLERO], boleros: [T_BOLERO],
      dress: [T_LONG, T_SHORT], dresses: [T_LONG, T_SHORT],
      /* 'long dress' / 'short dress' are handled as two-word phrases below */
      pant: [T_PANTS], pants: [T_PANTS], trouser: [T_PANTS], trousers: [T_PANTS],
      coat: [T_COAT], coats: [T_COAT], cape: [T_COAT], capes: [T_COAT],
      jacket: [T_COAT], jackets: [T_COAT],
      shirt: [T_TOP], shirts: [T_TOP], top: [T_TOP], tops: [T_TOP],
      blouse: [T_TOP], blouses: [T_TOP]
    };

    /* Two-word type phrases, checked before single words so "long dress"
       narrows to one type instead of both. */
    var TYPE_PHRASES = [
      ['long dress', [T_LONG]], ['long dresses', [T_LONG]],
      ['short dress', [T_SHORT]], ['short dresses', [T_SHORT]],
      ['maxi dress', [T_LONG]], ['midi dress', [T_LONG]],
      ['mini dress', [T_SHORT]]
    ];

    /* Shopify standard taxonomy ids — stable, so safe to hardcode.
       A bucket with no match in the current result set simply returns zero;
       that is correct behaviour, not a bug.

       Several of the store's own names are ambiguous and map to TWO buckets
       on purpose (repeated filter params are OR): carmine is filed under Pink
       in the catalogue but reads as red, vermilion is filed under both Orange
       and Red. Casting wide is right here — a shopper who types "red" should
       not miss a carmine gown. */
    var C = {
      BLACK: 1, BLUE: 2, WHITE: 3, BEIGE: 6, BROWN: 7, GRAY: 8, GREEN: 9,
      ORANGE: 10, PINK: 11, PURPLE: 12, RED: 13, YELLOW: 14, NAVY: 15,
      MULTI: 2865
    };

    var COLOUR_WORDS = {
      black: [C.BLACK], noir: [C.BLACK], obsidian: [C.BLACK], coal: [C.BLACK],
      onyx: [C.BLACK], jet: [C.BLACK], charcoal: [C.BLACK, C.GRAY],
      white: [C.WHITE], pearl: [C.WHITE], ivory: [C.WHITE], cream: [C.WHITE],
      blue: [C.BLUE, C.NAVY], cobalt: [C.BLUE], colbalt: [C.BLUE],
      sapphire: [C.BLUE], azure: [C.BLUE], cerulean: [C.BLUE],
      navy: [C.NAVY], indigo: [C.NAVY], midnight: [C.NAVY], prussian: [C.NAVY],
      beige: [C.BEIGE], oyster: [C.BEIGE], greige: [C.BEIGE], taupe: [C.BEIGE],
      stone: [C.BEIGE], sand: [C.BEIGE], nude: [C.BEIGE],
      brown: [C.BROWN], chocolate: [C.BROWN], coffee: [C.BROWN],
      grey: [C.GRAY], gray: [C.GRAY], slate: [C.GRAY], ash: [C.GRAY],
      green: [C.GREEN], jade: [C.GREEN], forest: [C.GREEN], verdant: [C.GREEN],
      emerald: [C.GREEN], olive: [C.GREEN],
      orange: [C.ORANGE], vermilion: [C.ORANGE, C.RED], tangerine: [C.ORANGE],
      saffron: [C.ORANGE, C.YELLOW], rust: [C.ORANGE],
      pink: [C.PINK], fuchsia: [C.PINK], magenta: [C.PINK], rose: [C.PINK],
      blush: [C.PINK],
      purple: [C.PURPLE], violet: [C.PURPLE], orchid: [C.PURPLE],
      plum: [C.PURPLE], lilac: [C.PURPLE], periwinkle: [C.PURPLE, C.BLUE],
      red: [C.RED], crimson: [C.RED], scarlet: [C.RED], carmine: [C.RED, C.PINK],
      ruby: [C.RED], burgundy: [C.RED],
      yellow: [C.YELLOW], ochre: [C.YELLOW], orche: [C.YELLOW],
      gold: [C.YELLOW], mustard: [C.YELLOW], amber: [C.YELLOW],
      multicolour: [C.MULTI], multicolor: [C.MULTI], multi: [C.MULTI],
      rainbow: [C.MULTI], print: [C.MULTI], printed: [C.MULTI]
    };

    var FABRIC_WORDS = {
      silk: 16997, silks: 16997, linen: 16989, linens: 16989,
      cotton: 16984, bamboo: 16981
    };

    var SIZE_WORDS = {
      xs: 'XS', m: 'M', l: 'L', xl: 'XL',
      small: 'S', medium: 'M', large: 'L',
      onesize: 'One size'
      /* 's' is deliberately absent — a lone "s" is far more likely to be the
         first keystroke of a word than a size request, and mapping it would
         make the panel lurch to size-S results while she is still typing.
         "small" covers the intent. 'one size' is handled as a phrase below. */
    };

    /* Words that carry intent but are not themselves searchable. Dropped
         rather than passed through: "size m" used to resolve the M facet and
         then send q=size, which matches nothing sensible and wasted the
         request. */
    var STOP_WORDS = {
      size: 1, sizes: 1, colour: 1, color: 1, coloured: 1, colored: 1,
      in: 1, a: 1, an: 1, the: 1, and: 1, with: 1, for: 1, me: 1, my: 1,
      show: 1, find: 1, all: 1
    };

    function uniq(a) {
      var out = [], seen = {};
      a.forEach(function (x) { if (!seen[x]) { seen[x] = 1; out.push(x); } });
      return out;
    }

    /* Turn the shopper's raw text into a set of facets plus whatever words
       were not recognised. Returns null when nothing at all resolved, which
       is the signal to send the query through untouched. */
    function resolve(text) {
      var lower = ' ' + text.toLowerCase().replace(/[^a-z0-9&\s]/g, ' ')
                              .replace(/\s+/g, ' ').trim() + ' ';
      var types = [], colours = [], fabrics = [], sizes = [];

      TYPE_PHRASES.forEach(function (pair) {
        if (lower.indexOf(' ' + pair[0] + ' ') >= 0) {
          types = types.concat(pair[1]);
          lower = lower.replace(' ' + pair[0] + ' ', ' ');
        }
      });

      /* "one size" before tokenising, or the two halves are read separately
         and "one" falls through to free text. */
      if (lower.indexOf(' one size ') >= 0) {
        sizes.push('One size');
        lower = lower.replace(' one size ', ' ');
      }

      var tokens = lower.trim().split(' ').filter(Boolean);

      /* A one- or two-letter token is only a size when something else in the
         query establishes that intent. On its own, "m" is the first keystroke
         of "midi" far more often than it is a size, and resolving it would
         yank the results to size M mid-word. So a bare "m"/"l"/"xs"/"xl" is
         only honoured alongside another token. */
      var soloLetterSize = tokens.length === 1 && tokens[0].length <= 2;

      var rest = [], dropped = 0;
      tokens.forEach(function (w) {
        if (TYPE_WORDS[w]) { types = types.concat(TYPE_WORDS[w]); return; }
        if (COLOUR_WORDS[w]) { colours = colours.concat(COLOUR_WORDS[w]); return; }
        if (FABRIC_WORDS[w]) { fabrics.push(FABRIC_WORDS[w]); return; }
        if (SIZE_WORDS[w] && !(soloLetterSize && w.length <= 2)) {
          sizes.push(SIZE_WORDS[w]); return;
        }
        if (STOP_WORDS[w]) { dropped++; return; }
        rest.push(w);
      });

      if (!types.length && !colours.length && !fabrics.length && !sizes.length) {
        /* Nothing resolved. If the only thing we did was drop stopwords there
           is no query left worth sending, so hand back null and let the caller
           use the raw text — never a bare stopword as the query. */
        return null;
      }
      return {
        types: uniq(types), colours: uniq(colours),
        fabrics: uniq(fabrics), sizes: uniq(sizes),
        rest: rest.join(' ')
      };
    }

    /* Build the /search URL. `q` is always present because Shopify filters
       narrow the result set of a query and an empty q matches nothing — so
       when every word resolved to a facet (someone typed just "black"), the
       query becomes an OR over every product type, which is the catalogue.

       type=product keeps pages and articles out, the same reason
       templates/search.count.liquid carries it. */
    var ALL_TYPES = [T_LONG, T_SHORT, T_TOP, T_BOLERO, T_COAT, T_PANTS];

    /* `human` builds the href behind "See all products", which a shopper both
       sees and lands on. It must NEVER carry a scoped `q` —
       sections/main-search.liquid prints search.terms into the results heading
       (`search.results_count_for_terms`), so `q=product_type:"Long dress" OR
       product_type:"Short Dress"` would head her results page with that raw
       string. She typed "dress"; the page has to say "dress".

       So the human link sends her own words as `q` and carries the narrowing in
       `filter.*`, which the results page also renders as removable chips. For
       "dress" that is q=dress + both type facets — still 27, because the facets
       narrow the 38 free-text hits down to exactly the dresses.

       A facet-only query ("black") has no workable /search form at all: q=black
       matches nothing, and filters narrow an empty set to an empty set. Those go
       to /collections/all instead, which needs no q — and, unlike search,
       supports sort_by=best-selling if that is ever wanted here. */
    function buildUrl(term, view, human) {
      var r = resolve(term);
      var p = [];
      var q;

      if (human && r && !r.rest && !r.types.length) {
        /* Colour / fabric / size only. Collection route, no q. */
        r.colours.forEach(function (id) {
          p.push('filter.v.t.shopify.color-pattern=' +
                 encodeURIComponent('gid://shopify/TaxonomyValue/' + id));
        });
        r.fabrics.forEach(function (id) {
          p.push('filter.v.t.shopify.fabric=' +
                 encodeURIComponent('gid://shopify/TaxonomyValue/' + id));
        });
        r.sizes.forEach(function (s) {
          p.push('filter.v.option.size=' + encodeURIComponent(s));
        });
        return '/collections/all' + (p.length ? '?' + p.join('&') : '');
      }

      if (!r) {
        q = term;
      } else if (r.rest) {
        q = r.rest;
      } else if (human) {
        /* Her own words, with the types carried as facets below. */
        q = term;
      } else {
        var scope = r.types.length ? r.types : ALL_TYPES;
        q = scope.map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ');
      }

      p.push('q=' + encodeURIComponent(q));
      p.push('type=product');
      if (view) p.push('view=' + view);

      if (r) {
        /* Send the type facet whenever something other than the type scope is
           carrying `q` — free text, or (on the human link) her own words. When
           the fetch URL's `q` IS the scope, the facet would be redundant. */
        if (r.types.length && (r.rest || human)) {
          r.types.forEach(function (t) {
            p.push('filter.p.product_type=' + encodeURIComponent(t));
          });
        }
        r.colours.forEach(function (id) {
          p.push('filter.v.t.shopify.color-pattern=' +
                 encodeURIComponent('gid://shopify/TaxonomyValue/' + id));
        });
        r.fabrics.forEach(function (id) {
          p.push('filter.v.t.shopify.fabric=' +
                 encodeURIComponent('gid://shopify/TaxonomyValue/' + id));
        });
        r.sizes.forEach(function (s) {
          p.push('filter.v.option.size=' + encodeURIComponent(s));
        });
      }
      return '/search?' + p.join('&');
    }

    var SHOW = 8;

    /* Recently-viewed product ids, written by Prestige's own
       <recently-viewed-products> (assets/theme.js:5711). Reused rather than
       tracked again so there is one source of truth; a corrupt or absent
       value must never take the search panel down with it. */
    function recentIds() {
      try {
        var v = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
        return Array.isArray(v) ? v.map(String) : [];
      } catch (e) { return []; }
    }

    /* Move anything she has already looked at to the front, in the order she
       looked at it. The template returns 24 rather than 8 precisely so this
       can reach a piece sitting at rank 12 — reordering 8 would almost never
       find one. Order only; nothing is added or removed. */
    function pinRecent(cards) {
      var ids = recentIds();
      if (!ids.length) return cards;
      var rank = {};
      ids.forEach(function (id, i) { rank[id] = i; });
      var seen = [], rest = [];
      cards.forEach(function (c) {
        var id = c.getAttribute('data-product-id');
        if (id && rank[id] !== undefined) seen.push(c); else rest.push(c);
      });
      seen.sort(function (a, b) {
        return rank[a.getAttribute('data-product-id')] -
               rank[b.getAttribute('data-product-id')];
      });
      return seen.concat(rest);
    }

    /* One request per keystroke, not two. templates/search.panel.liquid
       returns the products AND the total (data-chsr-count-value), so the
       separate ?view=count fetch this function used to make is gone.

       280ms matches the delay <predictive-search> used, which the merchant
       is used to; it was 320 here, so the panel now answers slightly sooner
       despite doing more. */
    function runSearch(term) {
      if (countTimer) clearTimeout(countTimer);
      if (!term) {
        if (countAbort) { countAbort.abort(); countAbort = null; }
        countEl.textContent = '';
        seeall.hidden = true;
        if (slot) { slot.replaceChildren(); slot.setAttribute('aria-busy', 'false'); }
        return;
      }

      /* The human-facing link keeps the resolved facets, so "See all" lands
         on the same set she is looking at rather than the loose free-text
         one. No view= — that is the real, styled results page. */
      seeallLink.setAttribute('href', buildUrl(term, null, true));

      countTimer = setTimeout(function () {
        if (countAbort) countAbort.abort();
        countAbort = new AbortController();
        var signal = countAbort.signal;
        if (slot) slot.setAttribute('aria-busy', 'true');
        /* The holding state used to ride on Prestige's theme:loading:* events,
           which <predictive-search> dispatched around its own fetch. That
           element is gone, so nothing fires them any more and the class has to
           be set here or the panel never shows it is working. */
        if (root.classList.contains('is-open')) root.classList.add('is-loading');

        fetchInto(buildUrl(term, 'panel'), signal, term);
      }, 280);
    }

    function fetchInto(url, signal, term, isRetry) {
      fetch(url, { signal: signal })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html === null) return;
          /* Never let a stale response paint. Two requests can be in flight at
             once — the zero-result retry below, plus whatever the next
             keystroke started — and without this the SLOWER one wins and
             overwrites the newer results. `signal.aborted` covers both a
             superseded keystroke and a closed panel; the identity check covers
             the window where a new AbortController has replaced this one but
             the old signal was never explicitly aborted. */
          if (signal.aborted || signal !== (countAbort && countAbort.signal)) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('[data-chsr-products]');
          if (!box) return;

          var n = parseInt(box.getAttribute('data-chsr-count-value'), 10);
          if (isNaN(n)) n = 0;

          /* Safety net. If narrowing by facet found nothing but the shopper
             clearly typed something real, fall back to the untouched query
             rather than showing her an empty panel. A resolver mistake then
             costs relevance, never results. */
          if (n === 0 && !isRetry) {
            var plain = '/search?q=' + encodeURIComponent(term) +
                        '&type=product&view=panel';
            if (plain !== url) { fetchInto(plain, signal, term, true); return; }
          }

          var cards = Array.prototype.slice.call(
            box.querySelectorAll('.chsr-res__card')
          );

          if (slot) {
            slot.replaceChildren();
            if (cards.length) {
              var grid = document.createElement('div');
              grid.className = 'chsr-res__grid';
              pinRecent(cards).slice(0, SHOW).forEach(function (c) {
                grid.appendChild(document.importNode(c, true));
              });
              slot.appendChild(grid);
            } else {
              var empty = box.querySelector('.chsr-res__empty');
              if (empty) slot.appendChild(document.importNode(empty, true));
            }
            slot.setAttribute('aria-busy', 'false');
          }

          countEl.textContent = n === 1 ? '1 result' : n + ' results';
          if (n > SHOW) {
            seeallLink.textContent = 'See all products (' + n + ')';
            seeall.hidden = false;
          } else {
            seeall.hidden = true;
          }
          syncEnd();
        })
        .catch(function () {
          if (slot) slot.setAttribute('aria-busy', 'false');
        })
        .then(function () {
          /* Not .finally() — this file is ES5 throughout and Prestige still
             targets browsers without it. A second .then() after .catch()
             runs on both paths, which is what finally would have given us. */
          root.classList.remove('is-loading');
        });
    }

    var terms = [];
    try {
      var raw = root.querySelector('[data-chsr-terms]');
      if (raw) terms = JSON.parse(raw.textContent).map(function (t) {
        return String(t).trim();
      }).filter(Boolean);
    } catch (e) { terms = []; }

    function escapeHtml(str) {
      return str.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* Wrap the matched run in <mark>, the same shape Shopify uses for its
       own styled_text, so both sources style identically. Case-insensitive
       and works mid-string — the reference shows both. The term is escaped
       BEFORE the marker goes in: the needle comes from the shopper's own
       keystrokes, so it must never reach innerHTML unescaped. */
    /* Marks EVERY word of the query, not just the first contiguous run.
       The old version took one indexOf of the whole needle, so "black bolero"
       matched nothing at all in "Tokyo Imperial Bolero" — neither word was
       highlighted, because the phrase as typed never appears.

       Builds a list of [start,end] hit ranges, merges overlaps, then walks the
       string once. Every slice is escaped before it goes anywhere near
       innerHTML: the needle is the shopper's own keystrokes. */
    function highlight(text, needle) {
      if (!needle) return escapeHtml(text);
      var hay = text.toLowerCase();
      var words = needle.toLowerCase().split(/\s+/).filter(function (w) {
        return w.length > 0;
      });
      var hits = [];
      words.forEach(function (w) {
        var from = 0, i;
        while ((i = hay.indexOf(w, from)) >= 0) {
          hits.push([i, i + w.length]);
          from = i + w.length;
        }
      });
      if (!hits.length) return escapeHtml(text);

      hits.sort(function (a, b) { return a[0] - b[0]; });
      var merged = [hits[0]];
      for (var k = 1; k < hits.length; k++) {
        var last = merged[merged.length - 1];
        if (hits[k][0] <= last[1]) {
          if (hits[k][1] > last[1]) last[1] = hits[k][1];
        } else {
          merged.push(hits[k]);
        }
      }

      var out = '', pos = 0;
      merged.forEach(function (r) {
        if (r[0] > pos) out += '<span>' + escapeHtml(text.slice(pos, r[0])) + '</span>';
        out += '<mark>' + escapeHtml(text.slice(r[0], r[1])) + '</mark>';
        pos = r[1];
      });
      if (pos < text.length) out += '<span>' + escapeHtml(text.slice(pos)) + '</span>';
      return out;
    }

    /* The element owns exactly one slot, so a single section cannot render
       into two columns. Products stay in the results column; the query
       block is carried across, and the catalogue terms are merged into the
       same list so there is one "Suggestions" heading, never two.

       Shopify's queries come first — they are real search history — then
       catalogue terms that are not already represented, capped at six. */
    function renderSuggestions() {
      if (!queriesSlot) return;
      var needle = input.value.trim();
      queriesSlot.replaceChildren();
      if (!needle) return;

      var items = [];
      var seen = {};

      /* Shopify's own query suggestions are gone with <predictive-search>.
         No loss on this store: the snippet's own note records that they come
         back empty for most words here ("silk", "ao", even "si" return
         nothing), which is why this local catalogue list was built in the
         first place. It matches on the FIRST keystroke with no round trip. */
      var lower = needle.toLowerCase();
      terms.forEach(function (t) {
        if (items.length >= 6) return;
        if (t.toLowerCase().indexOf(lower) < 0) return;
        if (seen[t.toLowerCase()]) return;
        seen[t.toLowerCase()] = 1;
        items.push('<a href="/search?q=' + encodeURIComponent(t) +
                   '&type=product">' + highlight(t, needle) + '</a>');
      });

      if (!items.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'chsr-sug';
      var label = document.createElement('p');
      label.className = 'chsr-sug__label';
      label.textContent = 'Suggestions';
      var ul = document.createElement('ul');
      ul.className = 'chsr-sug__list';
      ul.innerHTML = items.map(function (h) { return '<li>' + h + '</li>'; }).join('');
      wrap.appendChild(label);
      wrap.appendChild(ul);
      queriesSlot.appendChild(wrap);
    }

    /* The MutationObserver that used to watch predictive-search's slot is
       gone — this file now owns the render, so it calls syncEnd() itself at
       the end of fetchInto() rather than waiting to be told the DOM moved. */

    /* "when you scroll to the bottom the button expands" */
    function syncEnd() {
      if (!scroller || !col) return;
      var atEnd = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 4;
      col.classList.toggle('is-at-end', atEnd);
    }

    if (scroller) scroller.addEventListener('scroll', syncEnd, { passive: true });

    var _syncQuery = syncQuery;
    syncQuery = function () {
      _syncQuery();
      var term = input.value.trim();
      runSearch(term);
      renderSuggestions();
      if (!term) {
        queriesSlot.replaceChildren();
        if (scroller) scroller.scrollTop = 0;
        col.classList.remove('is-at-end');
      }
    };

    input.addEventListener('input', syncQuery);

    /* Prestige fires these on documentElement around the fetch. Using them
       rather than a timer means the holding state is tied to the actual
       request, so a slow network holds longer and a fast one barely shows. */
    document.documentElement.addEventListener('theme:loading:start', function () {
      if (root.classList.contains('is-open')) root.classList.add('is-loading');
    });
    document.documentElement.addEventListener('theme:loading:end', function () {
      root.classList.remove('is-loading');
    });

    input.addEventListener('search', function () { syncQuery(); });

    /* ──────────────────────────────────────────────────────────────────────
       Keyboard traversal. Before this the only way through the results was
       Tab, which walks the suggestion links first and gives no sense of a
       list — and on a panel whose whole point is the results, that is the
       wrong shape.

       Down from the field enters the results; Down/Up move within them; Up
       from the first card returns to the field with the caret intact so she
       can keep typing. Home/End jump the ends. Enter is left alone — the card
       is an <a>, so it already navigates, and the field's own Enter still
       submits the form.

       Bound on the panel, not the document, so it cannot touch the page
       behind. Escape is deliberately NOT handled here: the existing document
       listener already closes the panel, and a second handler would fight it. */
    function cards() {
      return slot ? Array.prototype.slice.call(
        slot.querySelectorAll('.chsr-res__card')
      ) : [];
    }

    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' &&
          e.key !== 'Home' && e.key !== 'End') return;

      var list = cards();
      if (!list.length) return;

      var here = list.indexOf(document.activeElement);
      var onField = document.activeElement === input;
      if (here < 0 && !onField) return;

      /* Home/End only mean "ends of the list" once she is IN the list —
         in the field they must stay as caret movement. */
      if ((e.key === 'Home' || e.key === 'End') && onField) return;

      var next;
      if (e.key === 'ArrowDown') {
        next = onField ? 0 : Math.min(here + 1, list.length - 1);
      } else if (e.key === 'ArrowUp') {
        if (here <= 0) {
          e.preventDefault();
          input.focus();
          /* Caret to the end, so Up out of the list leaves her ready to keep
             typing rather than with the whole query selected. */
          try { input.setSelectionRange(input.value.length, input.value.length); } catch (err) {}
          return;
        }
        next = here - 1;
      } else if (e.key === 'Home') {
        next = 0;
      } else {
        next = list.length - 1;
      }

      e.preventDefault();
      list[next].focus({ preventScroll: true });
      /* preventScroll above, then scroll the card into view ourselves —
         letting focus() do it jumps the whole panel on Safari. */
      if (list[next].scrollIntoView) {
        list[next].scrollIntoView({ block: 'nearest' });
      }
    });
  })();
